import React from 'react';
import { AlertTriangleIcon, CheckCircleIcon } from 'lucide-react';
export function CrisisMoment() {
  return <section className="py-16 border-t border-black text-center" data-id="element-40">
      <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-41">
        La Crisis que Todos Enfrentan{' '}
        <span className="text-orange-400" data-id="element-42">(Pero Nadie Habla)</span>
      </h2>
      <div className="bg-black/50 p-6 rounded-lg mb-10 max-w-3xl mx-auto shadow-lg" data-id="element-43">
        <p className="text-lg mb-6" data-id="element-44">
          Hace unos años, incluso los mejores productos de Shopify y afiliados
          se estrellaban porque:
        </p>
        <ul className="space-y-4 mb-6 max-w-md mx-auto text-left" data-id="element-45">
          <li className="flex items-start" data-id="element-46">
            <AlertTriangleIcon className="h-6 w-6 text-red-500 mr-2 flex-shrink-0 mt-1" data-id="element-47" />
            <span data-id="element-48">Sus funnels cargaban lento.</span>
          </li>
          <li className="flex items-start" data-id="element-49">
            <AlertTriangleIcon className="h-6 w-6 text-red-500 mr-2 flex-shrink-0 mt-1" data-id="element-50" />
            <span data-id="element-51">Sus páginas no emocionaban.</span>
          </li>
          <li className="flex items-start" data-id="element-52">
            <AlertTriangleIcon className="h-6 w-6 text-red-500 mr-2 flex-shrink-0 mt-1" data-id="element-53" />
            <span data-id="element-54">Sus VSLs no persuadían.</span>
          </li>
        </ul>
      </div>
      <div className="mb-10 max-w-3xl mx-auto" data-id="element-55">
        <p className="text-lg mb-6" data-id="element-56">
          Yo mismo lo viví. Mis campañas en Meta quemaban miles de dólares hasta
          que entendí la verdadera causa:
          <span className="font-bold text-orange-400" data-id="element-57">
            {' '}
            no era el producto, ni el targeting, ni el presupuesto. Era la falta
            de persuasión en cada paso del funnel.
          </span>
        </p>
        <p className="text-lg" data-id="element-58">
          Hoy, tras generar más de{' '}
          <span className="font-bold text-green-400" data-id="element-59">
            $50 millones en ventas personales
          </span>{' '}
          y guiar a estudiantes que juntos superaron los{' '}
          <span className="font-bold text-green-400" data-id="element-60">$500 millones</span>,
          descubrí que con IA + los prompts correctos, este cuello de botella
          desaparece.
        </p>
      </div>
      <div className="text-center" data-id="element-61">
        <CheckCircleIcon className="h-16 w-16 text-green-400 mx-auto mb-4" data-id="element-62" />
        <p className="text-xl font-bold text-green-400" data-id="element-63">
          La buena noticia: Este problema ahora tiene solución
        </p>
      </div>
    </section>;
}